const state = {
  currentLanguage: ""
};

const getters = {};

const actions = {};

const mutations = {
  setCurrentLanguage(state, lang) {
    state.currentLanguage = lang;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
